import {
  INSIGHTS_ERROR,
  RESET_INSIGHTS_OBJ,
  RESET_INSIGHTS_STATUS,  
  SET_INSIGHTS,
  SET_INSIGHTS_SUCCESS,
} from "./actionTypes";

const initialState = {
  status: {},
  data: {},
};

const Insights = (state = initialState, action) => {
  switch (action.type) {
    case INSIGHTS_ERROR:
      state = {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            error: {
              status: true,
              message: action?.payload?.message,
            },
            loading: false,
            success: false,
          },
        },
      };
      break;
      case RESET_INSIGHTS_OBJ:
      state = initialState;
      break;
    case RESET_INSIGHTS_STATUS:
      state = {
        ...state,
        status: {
          ...state.status,
          [action.payload]: null,
        },
      };
      break;
    case SET_INSIGHTS:
      state = {
        ...state,
        status: {
          ...state?.status,
          set_insights: {
            error: false,
            loading: true,
            success: false,
          },
        },
      };
      break;
    case SET_INSIGHTS_SUCCESS:
      state = {
        ...state,
        status: {
          set_insights: {
            error: false,
            loading: false,
            success:{
              status: true,
              data: action.payload,
            },
          },
        },
      };
      break;
    default:
      // do nothing
      break;
  }
  return state;
};

export default Insights;
